<template>
    <modal size="lg" @close="reset(); $emit('close')" ref="modal" :is-closeable="isCloseable" :autoshow="true">
        <template v-slot:title>
            <h3 class="modal-title">Edit Income Withholding Order Priority</h3>
        </template>

        <slot>
            <div class="mb-2">
                <div class="p-1 unpad-x bg-150 rounded">
                    <div><span class="text-muted">Employee: </span>{{ employee.full_name }}</div>
                    <div><span class="text-muted">Company: </span>{{ employee.company.name }}</div>
                </div>
            </div>

            <p>Drag to reorder the priority of income withholding orders</p>

            <div class="form-row handle border-bottom">
                <div class="col-5">
                    <h5 class="table-header-like">Name</h5>
                </div>
                <div class="col-3">
                    <h5 class="table-header-like">Order Date</h5>
                </div>
                <div class="col-3">
                    <h5 class="table-header-like">Amount</h5>
                </div>
                <div class="col-1">
                    <h5 class="table-header-like">Priority</h5>
                </div>
            </div>

            <VueDraggable
                v-model="formData.sorted_iwos"
                draggable=".draggable"
                handle=".handle"
                animation="200"
                ghost-class="ghost"
            >
                <div v-for="(iwo, idx) in formData.sorted_iwos" class="draggable">
                    <div class="form-row handle cursor-move bg-white border-bottom pt-1 pb-1">
                        <div class="col-5">
                            <i class="fas fa-grip-horizontal text-muted"></i> {{ iwo.iwo_type.name }}
                        </div>
                        <div class="col-3">
                            {{ $filters.date(iwo.order_date) }}
                        </div>
                        <div class="col-3">
                            {{ $filters.dollars(iwo.total_amount) }}/month
                        </div>
                        <div class="col-1">
                            {{ idx+1 }}
                        </div>
                    </div>
                </div>
            </VueDraggable>
        </slot>

        <template v-slot:footer>
            <form-errors :errors="formErrors"/>

            <button-row stacked>
                <button type="button" class="btn btn-outline-primary" @click.prevent="close()">
                    Cancel
                </button>

                <button type="button" class="btn btn-primary" @click.prevent="onSubmit()">
                    Save
                </button>
            </button-row>
        </template>
    </modal>
</template>

<script>
import { VueDraggable } from 'vue-draggable-plus'
import FormMixin from '@/mixins/Form'
import ModalMixin from '@/mixins/ModalMixin'

export default {
    props: ['client', 'employee', 'iwos'],
    mixins: [FormMixin, ModalMixin],
    components: {VueDraggable},
    emits: ['updated', 'close', ],
    data() {
        let sortedIWOs = [...this.iwos].sort((a, b) => {
            if (a.priority == null) return 1
            if (b.priority == null) return -1
            return a.priority - b.priority
        })
        const data = {
            formData: {
                sorted_iwos: sortedIWOs
            }
        }

        return data
    },
    computed: {
        company() {
            return this.client.companies.find(c => c.id == this.employee.company_id)
        }
    },
    methods: {
        getFormData() {
            return {
                'sorted_iwos': this.formData.sorted_iwos.map(iwo => iwo.id)
            }
        },
        onSubmit() {
            this.$store.dispatch('START_LOADING')
            return this.$api.post(`/clients/${this.client.id}/employees/${this.employee.id}/iwos/reorder`, this.getFormData()).then(resp => {
                this.$store.dispatch('STOP_LOADING')
                this.$bus.showInfo(`Successfully saved order priority.`)
                this.$emit('updated', resp)
                this.close()
            }).catch((errors) => {
                this.$store.dispatch('STOP_LOADING')
                this.errors = errors
                this.formErrors = (errors.__all__ || [])
                this.$bus.showError(errors.__all__)
            })
        },
    }
}
</script>
